import React, { useEffect, useState } from 'react';
import Navbar from '../../components/navbar/navbar';
import Footer from '../../components/foter/footer';
import InfoConcesionario from '../../components/concesionario/infoConcesionario';
import iconAgendar from '../../../img/floating/agendar.svg';
import iconCotizar from '../../../img/floating/cotizar.svg';
import iconUbicacion from '../../../img/concesionario/icono_ubicacion.svg';

import { Breadcrumb, Button, Popover, Tabs } from 'antd';
import { Col, Container, Row } from 'react-bootstrap';

import { Link, Redirect, useParams } from 'react-router-dom';
import clienteAxios from '../../../configAxios/configAxios';
import CentrosMantencion from '../../components/centrosMantencion/centrosMantencion';
import GoogleMapReact from 'google-map-react';

import MarkerIcon from '../../../img/mapa/marker.png'

import '../../../css/textsPredefined.css'
import './ficha.css'
import Seo from '../../components/seo/seo';
import LoaderContainerMobile from '../../components/loader/LoaderContainerMobile';

const { TabPane } = Tabs;

const Ficha = () => {

    const [oficina, setDatosOficina] = useState(undefined);

    const [servicios, setServicios] = useState([]);

    const { slugCon, slugOfi } = useParams();

    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        const fetchFichaConcesionario = async () => {
            try {
                setLoading(true);
                const body = {
                    slugConcesionario: slugCon,
                    slugOficina: slugOfi
                }
                let response = await clienteAxios.post('obtenerFichaConcesionarioPorSlug', body);

                if (response.status === 200) {
                    let data = response.data.data;
                    setDatosOficina(data.oficina);
                    setServicios(data.servicios);
                    setError(false);
                    setLoading(false);
                    return;
                }
                setError(true);
                setLoading(false);
            } catch (error) {
                setError(true);
                setLoading(false);
            }
        }
        fetchFichaConcesionario();
        // eslint-disable-next-line
    }, []);

    if (loading === true) return <LoaderContainerMobile />

    if ((!oficina && loading === false) || (error === true && loading === false)) return <Redirect to="/404" />;
    
    return (
        <>
            <Navbar whatsappVisible={true} />
            <CentrosMantencion seccion="CONCESIONARIOS" />
            <Seo title="Concesionario -" />
            <Container fluid className="mb-general">
                <Row>
                    <Col className="px-0">
                        <img src={oficina.Banner} className="img-fluid slider-md" alt={oficina.Nombre} />
                    </Col>
                </Row>
                <Row>
                    <Col className="my-1 my-md-3 px-2">
                        <Breadcrumb separator=">" className="parrafo-hyundai f-responsive-10">
                            <Breadcrumb.Item><Link to="/">Home</Link></Breadcrumb.Item>
                            <Breadcrumb.Item>
                                <Link to="/concesionarios">
                                    Concesionarios
                                </Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                                {oficina.Nombre ? oficina.Nombre : ""}
                            </Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                </Row>
                <Row>
                    <Col className="mx-auto d-none d-lg-block mt-5 " md={12} lg={12} xl={12}>
                        <Row>
                            {servicios && servicios.length > 0 && servicios.map((servicio, i) =>
                                (servicio.Estado === 'A' &&
                                    <Col key={i} className="text-center border-concesionarios mb-4">
                                        <h5 className="bold-title-hyundai">{servicio.Servicio === "Venta" ? "Venta vehículos" : servicio.Servicio === "Servicio" ? "Servicio técnico" : servicio.Servicio}</h5>
                                        <hr className="c-line" />
                                    </Col>
                                )
                            )}
                        </Row>
                        <Row>
                            {servicios && servicios.length > 0 && servicios.map((servicio, i) =>
                                (servicio.Estado === 'A' &&
                                    <Col className="text-center" key={i}>
                                        <InfoConcesionario datos={servicio} />
                                    </Col>
                                )
                            )}
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} className="px-0">
                        <Tabs className="d-lg-none mt-1 mt-md-4 tab-hyundai" centered>
                            {servicios && servicios.length > 0 && servicios.map((servicio) =>                            
                                (servicio.Estado === 'A' &&
                                    <TabPane tab={<h5 className="bold-title-hyundai mb-1 px-md-1 font-title-mobile">{servicio.Servicio === "Venta" ? "Venta vehículos" : servicio.Servicio === "Servicio" ? "Servicio técnico" : servicio.Servicio}</h5>} key={servicio.Servicio}>
                                        <InfoConcesionario datos={servicio} />
                                    </TabPane>
                                )
                            )}
                        </Tabs>
                    </Col>
                </Row>
                <Row className="mx-0">
                    <Col xs={12} className="brd-direccion-c mt-4 mt-md-5 mb-2 mx-auto text-center">
                        <p className="parrafo-hyundai my-1 f-responsive"> <img src={iconUbicacion} className="img-fluid icono-ubicacion" alt="ubicacion" />{oficina.Direccion}, {oficina.Comuna} - {oficina.Region}</p>
                    </Col>
                </Row>
                <Row>
                    <Col className="h-700 my-4 px-0">
                        {oficina && oficina.Localizacion &&
                            <MapaConcesionario localizacion={oficina.Localizacion} nombre={oficina.Nombre} direccion={oficina.Direccion} />
                        }
                    </Col>
                </Row>
            </Container>
            <BottomBar oficina={oficina} />
            <Footer float={true} />
        </>
    );
}

const Marker = (props) => {
    return (
        <Popover content={<p className="parrafo-hyundai color-black">{props.direccion}</p>} title={<h6 className="bold-title-hyundai" >{props.nombre}</h6>}>
            <div className="w-100 h-100 marker-concesionario"><img src={MarkerIcon} alt="marker" className="img-fluid marker-concesionario" /></div>
        </Popover>
    )
}

const MapaConcesionario = ({ localizacion, nombre, direccion }) => {

    if (!localizacion) return null;
    let lat = Number(localizacion.slice(0, localizacion.indexOf(",")));

    let lng = Number(localizacion.slice(localizacion.indexOf(",") + 1, localizacion.length));

    if (!lat || !lng) return null;
    return (
        <>


            <GoogleMapReact
                bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_API }}
                defaultCenter={{ lat: lat, lng: lng }}
                defaultZoom={18}
            >
                <Marker
                    lat={lat}
                    lng={lng}
                    nombre={nombre}
                    direccion={direccion}
                />
            </GoogleMapReact>
        </>
    )
}

const BottomBar = ({ oficina }) => {

    if (!oficina) return null;
    return (
        <Container className="bg-hyundai-light fixed-bottom floating-shadow" fluid>
            <Row>
                <Col xs={6} className="px-0 min-h-floating">
                    <Link to={{ pathname: '/agenda-tu-servicio', state: { idConcesionario: oficina.idConcesionario, idRegion: oficina.idRegion, idOficina: oficina.idOficina } }}>
                        <Button type="text" className="w-100 h-100 bold-title-hyundai">
                            <img src={iconAgendar} alt="Agenda tu servicio" className="img-fluid icon-floating mr-md-2 mr-lg-3" />
                            <h6 className="bold-title-hyundai d-none d-md-inline color-float">Agenda tu servicio</h6>
                            <p className="bold-title-hyundai mb-0 mt-1 font-floating-btn d-md-none color-btn-floating color-float">Agenda tu servicio</p>
                        </Button>
                    </Link>
                </Col>
                <Col xs={6} className="px-0 bg-cotizar-floating min-h-floating">
                    <Link to={{ pathname: '/cotizar', state: { idConcesionario: oficina.idConcesionario, idRegion: oficina.idRegion, idOficina: oficina.idOficina } }}>
                        <Button type="text" className="w-100 h-100  bold-title-hyundai ">
                            <img src={iconCotizar} alt="Cotizar" className="img-fluid icon-floating mr-md-2 mr-lg-3" />
                            <h6 className="bold-title-hyundai d-none d-md-inline text-white">Cotizar</h6>
                            <p className="bold-title-hyundai mb-0 mt-1 font-floating-btn  d-md-none text-white">Cotizar</p>
                        </Button>
                    </Link>
                </Col>
            </Row>
        </Container>
    )
};
export default Ficha;